import { createServerFn } from '@tanstack/react-start';

import type { MembershipOrganization } from '@/utils/session/fetch-researcher-memberships';

import { fetchResearcherMemberships } from '@/utils/session/fetch-researcher-memberships';
import { getServerSession } from '@/utils/session/get-server-session';
import { decideWorkspaceOptions } from '@/utils/session/workspace-options';

/**
 * The organizations and teams the signed-in researcher can switch to, for the
 * settings menu's organization and team pickers. Reads the user from the
 * session rather than accepting a user id, because `fetchResearcherMemberships`
 * lists whatever user it is given. Empty when the lookup fails, which leaves
 * the pickers as plain headings.
 */
export const getWorkspaceSwitcherOptions = createServerFn().handler(
  async (): Promise<MembershipOrganization[]> => {
    const session = await getServerSession();
    const user = session?.user;
    if (!user?.roles?.includes('researcher')) return [];

    const result = await fetchResearcherMemberships({
      data: { userId: user.id },
    });
    const options = decideWorkspaceOptions(result, user.teams ?? []);
    return options.status === 'choose' ? options.memberships : [];
  },
);
